import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../../Manage/ManageTable';
import PopupModal from '../../../Manage/PopupModal';
import { Col, Row } from 'reactstrap';
import { NewsLetterStyle } from '../../../../StyledComponents';
import { IoCaretBackOutline } from 'react-icons/io5';
import JobApplicationDesc from '../JobApplicationDesc';

const Pending = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);


  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
      setShowForm(false);
  };

  const [data, setData] = useState([]);

  const clickHandler = (data) => {
      setShowForm(true);
      setData(data)
  };

  const jobData = [
    {
      jobTitle: "Software Engineer",
      applicationId: "APP12345",
      date: "30/04/2024",
      status: "Pending",
      action: "View details"
    },
    {
      jobTitle: "Marketing Spec.",
      applicationId: "APP12345",
      date: "30/04/2024",
      status: "Pending",
      action: "View details"
    },
  ];

  useEffect(() => {
    // Simulate fetching data
    setTableData(jobData);
    setLoading(false);
  }, []);

  const columns = [
    {
      name: "Job Title",
      cell: (row) => <span title={row.jobTitle} className="ellipsis">{row.jobTitle}</span>,
      selector: (row) => row.jobTitle,
      sortable: true,
    },
    {
      name: "Application ID",
      cell: (row) => <span title={row.applicationId} className="ellipsis">{row.applicationId}</span>,
      selector: (row) => row.applicationId,
      sortable: true,
    },
    {
      name: "Date",
      cell: (row) => <span title={row.date} className="ellipsis">{row.date}</span>,
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          title={row.status}
          className="ellipsis"
          style={{ color: row.status === 'Under Review' ? '#FBBD34' : row.status === 'Interview Scheduled' ? '#41B8E4' : row.status === 'Pending' ? '#EC7426' : '#000' }}
        >
          {row.status}
        </span>
      ),
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <span title='View Details' className="ellipsis">
          <div style={{ cursor: 'pointer' }} onClick={() => clickHandler(row)}>View Details</div>
        </span>
      ),
      selector: (row) => row.action,
      sortable: true,
    },
  ];


  return (
    <>
    {showForm ? (
      <>
          <Row className='px-4 p-2'>
              <Col xl='1' lg='1' md='1' sm='12' xs='12'><NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => setShowForm(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle></Col>
              <Col xl='11' lg='11' md='11' sm='12' xs='12'>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                      <NewsLetterStyle style={{ fontWeight: '700' }}>Application Description</NewsLetterStyle>
                  </div>
                  <JobApplicationDesc data={data} showState={handleAdd} onCancel={() => setShowForm(false)} />
              </Col>
          </Row>
      </>
  ) : (
      <div>
        {loading ? <Loader /> :
          <ManageTable
            name={'Pending'}
            columns={columns}
            setTableData={setTableData}
            tableData={tableData}
          />
        }
      </div>
)}
    </>
  );
};

export default Pending;
